import { inflate } from 'pako'
import { ENV } from '../../constants/generic'

const base64ToUint8Array = (b64: string): Uint8Array => Uint8Array.from(atob(b64), (c) => c.charCodeAt(0))

export const unzipb64Payload = (payload: string) => {
  try {
    const decoded = base64ToUint8Array(payload)
    const inflated = inflate(decoded)
    const restoredJsonString = new TextDecoder().decode(inflated)

    const restoredJson = JSON.parse(restoredJsonString)
    return restoredJson
  } catch (e) {
    if (process.env.NODE_ENV === ENV.DEV) {
      console.error('Error unzipping payload...', [e, payload])
    }
    return undefined
  }
}

export const b64decode = (data: string): string => {
  const decoded = base64ToUint8Array(data)
  const inflated = inflate(decoded)
  return new TextDecoder().decode(inflated)
}
// import { ENV } from '../../constants/generic'
// import { Buffer } from 'buffer'
// import { unzipSync } from 'browserify-zlib'

// export const unzipb64Payload = (payload: string) => {
//   try {
//     if (payload === undefined) {
//       return undefined
//     }
//     const decodedPayload = Buffer.from(payload, 'base64')
//     const restoredBuffer = unzipSync(decodedPayload)
//     const restoredJsonString = Buffer.from(restoredBuffer).toString('utf-8')
//     const restoredJson = JSON.parse(restoredJsonString)
//     return restoredJson
//   } catch (e) {
//     const err: any = e
//     if (process.env.NODE_ENV === ENV.DEV) console.log('Error unzipping payload...', [err.toString(), Buffer.from(payload, 'base64')])
//     return undefined
//   }
// }

// export const b64decode = (data: any) => {
//   const decodedPayload = Buffer.from(data, 'base64')
//   // console.log('B64 decoded string is: ', decodedPayload)
//   const restoredBuffer = unzipSync(decodedPayload)
//   const restoredString = Buffer.from(restoredBuffer).toString('utf-8')
//   return restoredString
// }
